import ScmUser from "./user/user"
import ScmORG from "./org/org"
import ScmInve from "./inventory/inventory"
import ScmMaterial from "./material/material"
import ScmDictionary from "./base/dictionary"
import ScmPurchase from "./purchase/purchase.js"
import ScmSale from "./sale/sale.js"
import ScmSupplier from "./supplier/supplier.js"
import ScmWorkflow from "./workflow/workflow.js"
import ScmSaleBill from "./bill/salebill.js"
import ScmAnnouncement from "./base/announcement"
import ScmCompute from "./compute/compute.js"
import ScmFile from "./file/file.js"
import ScmInterface from "./base/interfacemg"


const User = new ScmUser();
const Org = new ScmORG();
const Inventory = new ScmInve();
const Material = new ScmMaterial();
const Dict = new ScmDictionary();
const Purchase = new ScmPurchase();
const Sale = new ScmSale();
const Supplier = new ScmSupplier();
const Workflow = new ScmWorkflow();
const SaleBill = new ScmSaleBill();
const Announcement = new ScmAnnouncement();
const Compute = new ScmCompute();
const File = new ScmFile();
const Interface=new ScmInterface();


export default {
    User,
    Inventory,
    Org,
    Material,
    Dict,
    Purchase,
    Sale,
    Supplier,
    Workflow,
    SaleBill,
    Announcement,
    Compute,
    File,
    Interface,
}